
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popular",
      function () {
        return require("private-next-pages/popular/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popular"])
      });
    }
  